import { gql } from '@apollo/client/core'

export const REVIEW_FRAGMENT = gql`
  fragment Review on Review {
    id
    booking {
      ... on GetBookingOutput {
        booking {
          id
          bookingDate
          bookingType
          event {
            ... on GetEventOutput {
              event {
                name
              }
            }
          }
        }
      }
    }
    createdAt
    updatedAt
    updateCutoff
    rating
    body
    attributes {
      id
      name
      icon
    }
    gallery
    galleryPaths
    response {
      id
      userId
      reviewId
      body
      createdAt
      updatedAt
    }
    user {
      ... on GetUserOutput {
        user {
          username
          profilePicture
          firstName
          lastName
        }
      }
    }
    club {
      ... on GetClubOutput {
        club {
          id
          clubName
          logo
        }
      }
    }
  }
`
